import React, { useState } from 'react';
import { Box, Drawer, Card, CardContent, Typography, CardHeader, CircularProgress } from '@mui/material';
import api from "../../../../services/api";
import FormAddEditToolbar from "../../../../components/global/AddEditBar";
import { useNavigate } from 'react-router-dom';
import { useNotifier } from "muinotify";
import CategoryTypeForm from "../CategoryTypeForm";
import useSWR, { mutate } from 'swr';
import ErrorNotification from '../../../../components/ErrorNotification/ErrorNotification';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
    pct_aa: yup.number().nullable(true),
    pct_descr: yup.string().required('Το πεδίο είναι υποχρεωτικό'),
});

const CategoryTypeAdd = ({ onClose, prod_id }) => {
    const navigate = useNavigate();
    const { notifier } = useNotifier();
    const [drawerOpen, setDrawerOpen] = useState(true);

    const [state, setState] = useState({
        pc_pruduction_id: prod_id,
        pct_descr: '',
        pct_aa: 0,
    });

    const headerNames = {
        pct_descr: 'Category type description',
        pct_aa: 'Category type aa',
    };

    const URL = `production-category-type`;
    const NAV_PATH = `category_type`;

    const [errorMessage, setErrorMessage] = useState();
    const [errors, setErrors] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);

    function updateField(fieldName, value) {
        setState({ ...state, [fieldName]: value });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await validationSchema.validate(state, { abortEarly: false });
            setErrors({});
            setIsUpdating(true);
            api.post(`/${URL}/`, state)
                .then(response => {
                    mutate(`/${NAV_PATH}`);
                    notifier("New category type inserted.", { variant: "success" });
                    setDrawerOpen(false);
                })
                .catch(error => {
                    setErrorMessage(error);
                    notifier(<ErrorNotification error={error} />, { variant: "error" });
                })
                .finally(() => {
                    setIsUpdating(false);
                    if (onClose) {
                        onClose();
                    } else {
                        navigate(-1);
                    }
                });
        } catch (validationErrors) {
            const formattedErrors = {};
            validationErrors.inner.forEach((error) => {
                formattedErrors[error.path] = error.message;
            });
            setErrors(formattedErrors);
        }
    };

    const handleSave = () => {
        const form = document.getElementById(`${URL}-form`);
        if (form) {
            form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
    };

    const handleCancel = () => {
        if (onClose) {
            onClose();
        } else {
            navigate(-1);
        }
    };

    return (
        <>
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleCancel}
                PaperProps={{
                    style: {
                        width: '100%',
                        height: '100vh',
                        maxWidth: 600,
                        display: 'flex',
                        flexDirection: 'column',
                    },
                }}
            >
                <Card
                    sx={{
                        width: '100%',
                        maxWidth: 800,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        textAlign: 'center',
                    }}
                >
                    {/* Header Section */}
                    <Box justifyContent="center" alignItems="center" width="100%">
                        <CardHeader
                            title={
                                <Typography variant="h3" gutterBottom>
                                    Προσθήκη τύπου κατηγορίας
                                </Typography>
                            }
                        />
                    </Box>

                    {/* Scrollable Content Section */}
                    <CardContent
                        sx={{
                            display: 'flex',
                            height: '100vh',
                            flexGrow: 1,
                            overflowY: 'auto',
                            margin: 'initial',
                        }}
                    >
                        <form id={`${URL}-form`} onSubmit={handleSubmit}>
                            <CategoryTypeForm
                                state={state}
                                errors={errors}
                                updateField={updateField}
                                prod_id={prod_id}
                            />
                        </form>
                        {isUpdating && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                    zIndex: 1000,
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        )}
                    </CardContent>

                    {/* Toolbar (Footer Section) */}
                    <Box >
                        <FormAddEditToolbar
                            handleSave={handleSave}
                            handleCancel={handleCancel}
                        />
                    </Box>
                </Card>
            </Drawer >
        </>
    );
};

export default CategoryTypeAdd;
